import { render } from "./TransactionPaymentDetail.vue?vue&type=template&id=4a713696&scoped=true&ts=true"
import script from "./TransactionPaymentDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionPaymentDetail.vue?vue&type=script&lang=ts"

import "./TransactionPaymentDetail.vue?vue&type=style&index=0&id=4a713696&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a713696"]])

export default __exports__